/* Editorial motion only; the native Shopify gallery and product form keep their own events. */
(() => {
  const initialize = (root = document) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const elements = root.querySelectorAll('.hs-story .hs-copy, .hs-story-media, .hs-detail-grid > div');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hs-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });
    elements.forEach(element => {
      if (element.classList.contains('hs-reveal')) return;
      element.classList.add('hs-reveal');
      observer.observe(element);
    });
    document.body.classList.add('hs-motion');
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
